import ModalCard from "@/app/components/ModalCard";
import SendRequestButton from "@/app/components/RequestButton";
import RequestForm from "@/app/components/ServiceRequestForm";
import { Service, UserData } from "@/lib/api/types";
import { getBusinessForMemberId } from "@/consts/editionStudio";
import { resolveBusinessForLocation } from "@/lib/api/openingsLocations";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";

const ServiceConsultation = ({
  userId,
  userName,
  services,
  locations = [],
}: {
  userId: string;
  userName: string;
  services: Service[];
  locations?: UserData["schedules"];
}) => {
  const [isRequestFormActive, setRequestFormActive] = React.useState(false);

  // A stylist at two businesses has a different member id in each, and the
  // request is sent with this one. Offer only this member's business's
  // locations: a location from the other business would make the request's
  // identifiers disagree, which the write path refuses.
  const memberBusiness = getBusinessForMemberId(userId);
  const locationOptions = locations
    .filter(
      (location) =>
        !memberBusiness ||
        resolveBusinessForLocation(location.locationId) === memberBusiness,
    )
    .map((location) => ({
      scheduleId: location._id,
      locationId: location.locationId,
      name: location.locationName,
      address: location.locationAddress,
    }));

  return (
    <>
      <Paragraph>
        This service requires a quick review before booking.
      </Paragraph>

      <SendRequestButton onClick={() => setRequestFormActive(true)} />

      {/* {isRequestFormActive && ( */}
      <ModalCard
        destroyOnHidden={true}
        open={isRequestFormActive}
        title="Service request"
        onClose={() => {
          setRequestFormActive(false);
        }}
      >
        <RequestForm
          userId={userId}
          userName={userName}
          locationOptions={locationOptions}
          services={services}
          onClose={() => setRequestFormActive(false)}
        />
      </ModalCard>
      {/* )} */}
    </>
  );
};

export default ServiceConsultation;
